import {Directive, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: 'input[handleEventCodeProcess]'
})
export class HandleEventCodeProcessDirective {
  @Output('enter-press') private pressEnter: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();
  private lastCharCode: number | null = null;

  @HostListener('keyup', ['$event']) detectEnterPress(event: KeyboardEvent) {
    if (event.key === 'Process' || event.which === 229 || event.keyCode === 229){
      const lastCharCode = (event.target as any).value.substr(-1).charCodeAt(0);
      if (event.isComposing === false) {
        if (this.lastCharCode === lastCharCode) {
          const eventInit: KeyboardEventInit = {
            code: 'Enter',
            view: event.view,
            key: 'Enter',
            isComposing: false
          };
          console.log('raise enter');
          this.pressEnter.emit(new KeyboardEvent('keyup', eventInit));
        }
      } else
        this.lastCharCode = lastCharCode;
    }
  }
}
